import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import MediaUrlField from '../MediaUrlField/MediaUrlField';
import HeadlineField from '../HeadlineField/HeadlineField';
import DescriptionField from '../DescriptionField/DescriptionField';
import ThumbnailField from '../ImageUpload/ThumbnailField';
import BrandLogoField from '../ImageUpload/BrandLogoField';
import materialTheme from '../../reactMaterialTheme';
import { useCreativeInput } from '../../hooks';
import './ScrollerBuilder.scss';

const ScrollerBuilder = props => {
  const [creative, setCreative] = React.useState(props.creative);

  const creativeInputProps = useCreativeInput(
    [
      'advertiser',
      'headline',
      'description',
      'name',
      'mediaUrl',
      'thumbnailUrl',
      'scrollDirection',
      'brandLogoUrl'
    ],
    creative,
    setCreative,
    props.CreativeService
  );

  const onThumbnailUrlChange = url => {
    props.CreativeService.set('thumbnailUrl', url);
    setCreative({
      ...creative,
      thumbnailUrl: url
    });
  };

  const handleOgResponse = ogResponse => {
    const newCreative = { ...props.creative, ...ogResponse };
    setCreative(newCreative);
    props.CreativeService.set('headline', newCreative.headline);
    props.CreativeService.set('description', newCreative.description);
    props.CreativeService.set('thumbnailUrl', newCreative.thumbnailUrl);
  };

  React.useEffect(function setDefaultScrollDirection() {
    if (!creative.scrollDirection) {
      setCreative({
        ...creative,
        scrollDirection: 'bottom_to_top'
      });
      props.CreativeService.set('scrollDirection', 'bottom_to_top');
    }
  }, []);

  return (
    <MuiThemeProvider theme={materialTheme}>
      <div className="ad-builder">
        <TextField
          {...creativeInputProps.nameProps}
          label="Ad Name"
          className="col-xs-10"
          inputProps={{ 'data-testid': 'creative-name-input' }}
          required
        />
        <TextField
          {...creativeInputProps.advertiserProps}
          label={
            <label htmlFor={creativeInputProps.advertiserProps.id}>
              Brand Name
            </label>
          }
          className="col-xs-10"
          onFocus={event => event.target.select()}
          required
        />
        <BrandLogoField
          logoUrl={creativeInputProps.brandLogoUrlProps.value}
          onLogoUrlChange={creativeInputProps.brandLogoUrlProps.onChange}
        />
        <MediaUrlField
          mediaUrl={creativeInputProps.mediaUrlProps.value}
          onChange={creativeInputProps.mediaUrlProps.onChange}
          creative={props.creative}
          OpenGraphDataService={props.OpenGraphDataService}
          onOgResponse={handleOgResponse}
          CreativeService={props.CreativeService}
        />
        <ThumbnailField
          action="scroller"
          thumbnailUrl={creative.thumbnailUrl}
          onChange={onThumbnailUrlChange}
        />
        <HeadlineField
          headline={creativeInputProps.headlineProps.value}
          onChange={creativeInputProps.headlineProps.onChange}
        />
        <DescriptionField
          description={creativeInputProps.descriptionProps.value}
          onChange={creativeInputProps.descriptionProps.onChange}
        />
        <div className="mt2 mb2">
          Scroll Direction
          <span className="ml2">
            <label
              className={`btn ${
                creative.scrollDirection === 'bottom_to_top'
                  ? 'btn-primary'
                  : 'btn-secondary'
              } mr1`}
            >
              <input
                hidden
                type="radio"
                checked={creative.scrollDirection === 'bottom_to_top'}
                {...creativeInputProps.scrollDirectionProps}
                value="bottom_to_top"
              />
              <div className="scroll-direction-btn-text">
                <Icon>keyboard_arrow_up</Icon>
                Bottom to Top
              </div>
            </label>
            <label
              className={`btn ${
                creative.scrollDirection === 'top_to_bottom'
                  ? 'btn-primary'
                  : 'btn-secondary'
              }`}
            >
              <input
                hidden
                type="radio"
                checked={creative.scrollDirection === 'top_to_bottom'}
                {...creativeInputProps.scrollDirectionProps}
                value="top_to_bottom"
              />
              <div className="scroll-direction-btn-text">
                <Icon>keyboard_arrow_down</Icon>
                Top to Bottom
              </div>
            </label>
          </span>
        </div>
      </div>
    </MuiThemeProvider>
  );
};

ScrollerBuilder.propTypes = {
  CreativeService: PropTypes.object.isRequired,
  creative: PropTypes.object.isRequired,
  $modal: PropTypes.object.isRequired,
  $rootScope: PropTypes.object.isRequired,
  OpenGraphDataService: PropTypes.object.isRequired
};

export default ScrollerBuilder;
